export function trimTrailingZeros(
  value: number | string | null | undefined,
  maximumFractionDigits = 2
): string {
  if (value === null || value === undefined || value === '') return ''

  const num =
    typeof value === 'number' ? value : Number(String(value).replace(',', '.'))

  if (Number.isNaN(num)) return String(value)

  return num.toFixed(maximumFractionDigits).replace(/\.?0+$/, '')
}
